import { useEffect, useState } from "react";

let featureItemTimeout = null;
const useProductUpdateForm = ({ errors, formData }) => {
  const [blocksWithError, setBlocksWithError] = useState([]);

  useEffect(() => {
    if (errors && Object.values(errors).length > 0) {
      var errs = Object.keys(errors);
      var withError = [];
      Object.keys(formData).forEach((block) => {
        var blockObj = formData[block];
        Object.keys(blockObj).forEach((attribute, atk) => {
          if (errs.includes(attribute)) {
            withError.push(block);
          }
        });
      });
      setBlocksWithError(withError);
    } else {
      setBlocksWithError([]);
    }
  }, [errors]);

  useEffect(() => {
    setTimeout(() => {
      var elem = document.querySelector(".hasError");
      if (elem) {
        elem.scrollIntoView();
        clearTimeout(featureItemTimeout);
        featureItemTimeout = setTimeout(() => {
          window.scrollTo(0, window.scrollY - 90);
        }, 800);
      }
    }, 700);
  }, [blocksWithError]);

  return {
    blocksWithError,
  };
};

export default useProductUpdateForm;
